import { status } from "./status.js";
import { tl } from "./multilang.js";

let userInteraction = "";
let messageTimeOut = 3600;

export function fancyAlert(text, title = tl("Notification"), buttonTextOk = tl("OK"), type = "DANGER") {

    return new Promise((resolve) => {
        status.update((currentValue) => {
            currentValue.notification.show = true;
            currentValue.notification.text = text;
            currentValue.notification.title = title;
            currentValue.notification.type = type;
            currentValue.notification.buttonTextOk = buttonTextOk;
            return(currentValue);
        });

        userInteraction = resolve;
    });
}

export function fancyConfirm(text, title = tl("Confirmation"), buttonTextOk = tl("OK"), buttonTextCancel=tl("Cancel"), type="DANGER") {

    return new Promise((resolve) => {
        status.update((currentValue) => {
            currentValue.notification.show = true;
            currentValue.notification.text = text;
            currentValue.notification.title = title;
            currentValue.notification.type = type;
            currentValue.notification.buttonTextOk = buttonTextOk;
            currentValue.notification.buttonTextCancel = buttonTextCancel;
            currentValue.notification.confirm = true;
            return(currentValue);
        });

        userInteraction = resolve;
    });
}

export function fancyMessage(title, text = "", timeOut = messageTimeOut) {
    
    status.update((currentValue) => {
        currentValue.message.show = true;
        currentValue.message.text = text;
        currentValue.message.title = title;
        return(currentValue);
    });

    setTimeout(() => {
        status.update((currentValue) => {
            currentValue.message.show = false;
            return(currentValue);
        }); 
    }, timeOut);
}

export function handleCancel() {
    if (userInteraction) {
        hideNotification();
        userInteraction(false);
        userInteraction = "";
    }
}

export function handleConfirm() {
    if (userInteraction) {
        hideNotification();
        userInteraction(true);
        userInteraction = "";
    }
}

function hideNotification()  {

    status.update((currentValue) => {
        currentValue.notification.show = false;
        currentValue.notification.confirm = false;
        return(currentValue);
    });

}